import { CountyData } from "../CountyData";

function GreenCounty({ county }) {
  const staff = CountyData[county].staff;
  const phone = CountyData[county].phone;
  const email = CountyData[county].email;
  const blurb = CountyData[county].blurb;
  const annualbudget = CountyData[county].annualBudget;
  const imageLocation = CountyData[county].imageLocation;
  const caseStatementLink = CountyData[county].caseStatementLink;
  const givingLink = CountyData[county].givingLink;
  // todo: make this smart
  const extraGivingLink = CountyData[county].extraGivingLink;

  return (
    <>
      <img src={imageLocation} alt="Staff Person" />
      <div className="card-body">
        <p className="card-text text-secondary">Staff: {staff}</p>
        <p className="card-text text-secondary fw-bold">
          Phone: {phone} <br /> Email: {email}
        </p>
        <p className="card-text text-secondary">{blurb}</p>
        <p className="card-text text-secondary">
          Annual Budget: {annualbudget}
        </p>
        <div className="d-flex justify-content-around">
          <a
            href={caseStatementLink}
            target="_blank"
            rel="noreferrer noopener"
            className={`btn btn-primary btn-sm text-secondary ${!caseStatementLink ? " disabled" : ""
              }`}
          >
            Case Statement
          </a>
          <a
            href={givingLink}
            target="_blank"
            rel="noreferrer noopener"
            className={`btn btn-primary btn-sm text-secondary ${!givingLink ? " disabled" : ""
              }`}
          >
            Give{extraGivingLink ? ' (David)' : ''}
          </a>
          {extraGivingLink && 
            <a
              href={extraGivingLink}
              target="_blank"
              rel="noreferrer noopener"
              className={`btn btn-primary btn-sm text-secondary ${!givingLink ? " disabled" : ""
                }`}
            >
              Give{extraGivingLink ? ' (Marcos)' : ''}
            </a>}
        </div>
      </div>
    </>
  );
}

export default GreenCounty;
